class FiltersDrawer extends MainDrawer {
  constructor() {
    super();

    // Use a more robust approach to find the trigger
    this.setupTrigger();
  }

  setupTrigger() {
    // Try to find the trigger immediately
    this.trigger = document.querySelector('.drawer__trigger--filter');

    if (this.trigger) {
      this.trigger.addEventListener('click', () => this.loadAssets());
    } else {
      // If not found, try again after a short delay
      setTimeout(() => {
        this.trigger = document.querySelector('.drawer__trigger--filter');
        if (this.trigger) {
          this.trigger.addEventListener('click', () => this.loadAssets());
        }
      }, 100);
    }
  }

  loadAssets() {
    if (!document.getElementById('FACETSCSS') && !document.getElementById('FACETSJS')) {
      this.classList.add('loading');
    }

    loadCss('facets')
      .then(() => {
        setTimeout(() => {
          this.classList.remove('loading');
        }, 300);
      })
      .catch((error) => {
        console.error(error);
      });
    loadScript('facets').catch((error) => {
      console.error(error);
    });
    this.openDrawer();

    setTimeout(() => {
      if (typeof FacetFiltersForm !== 'undefined' && FacetFiltersForm.updateDrawerCount) {
        FacetFiltersForm.updateDrawerCount();
      }
    }, 200);
  }
}
customElements.define('filters-drawer', FiltersDrawer);

class SortDrawer extends MainDrawer {
  constructor() {
    super();

    // Use a more robust approach to find the trigger
    this.setupTrigger();
  }

  setupTrigger() {
    // Try to find the trigger immediately
    this.trigger = document.querySelector('.drawer__trigger--sort');

    if (this.trigger) {
      this.trigger.addEventListener('click', () => this.loadAssets());
    } else {
      // If not found, try again after a short delay
      setTimeout(() => {
        this.trigger = document.querySelector('.drawer__trigger--sort');
        if (this.trigger) {
          this.trigger.addEventListener('click', () => this.loadAssets());
        }
      }, 100);
    }
  }

  loadAssets() {
    if (!document.getElementById('FACETSCSS') && !document.getElementById('FACETSJS')) {
      this.classList.add('loading');
    }

    loadCss('facets')
      .then(() => {
        setTimeout(() => {
          this.classList.remove('loading');
        }, 300);
      })
      .catch((error) => {
        console.error(error);
      });
    loadScript('facets').catch((error) => {
      console.error(error);
    });
    this.openDrawer();
  }
}
customElements.define('sort-drawer', SortDrawer);
